const doc = [({"en":({"adminButtonHotel":({"backToHotelShow":"BACK TO HOTEL", "changeChannelManager":"Change channel manager"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;